import { type FC } from 'react';
import InstantIcon from '@assets/img/icons/Instant_icon.svg?react';
import XIcon from '@assets/img/icons/x-icon.svg?react';

import { CounterUpDown } from '@/components/CounterUpDown/CounterUpDown';

import styles from './styles.module.scss';

interface AmountToProduceProps {
  value: number;
  onCancel: () => void;
  onBoost: () => void;
  cancelDisabled?: boolean;
}

const AmountToProduce: FC<AmountToProduceProps> = ({
  value,
  onBoost,
  onCancel,
  cancelDisabled,
}) => {
  return (
    <div className="flex gap-4 items-center">
      <button
        className={styles.button}
        onClick={onCancel}
        disabled={cancelDisabled}
      >
        <XIcon className="size-6" />
      </button>

      <CounterUpDown
        className={styles.title}
        value={value}
        delay={0}
        duration={0.7}
      />

      <button className={styles.button} onClick={onBoost}>
        <InstantIcon className="size-6" />
      </button>
    </div>
  );
};

export default AmountToProduce;
